/**
 * Lectura del payload de un JWT **sin verificar la firma**. Es solo para
 * leer datos que el servidor igual valida en cada request (decisión D-3 de
 * la tanda 2). Nunca usar el resultado para decidir permisos.
 *
 * Claims del token del core: `sub`, `tenantId`, `rol`, `tipoInterfaz`,
 * `iat`, `exp` (`docs/backend/CLAUDE.md` §2.1).
 */

/** Decodifica el segmento de payload (base64url) a objeto. `null` si no es un JWT legible. */
export function leerPayloadJwt(token: string): Record<string, unknown> | null {
  const partes = token.split('.');
  const payload = partes[1];
  if (partes.length !== 3 || payload === undefined || payload === '') return null;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const relleno = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const bytes = Uint8Array.from(atob(relleno), (c) => c.charCodeAt(0));
    const json: unknown = JSON.parse(new TextDecoder().decode(bytes));
    return typeof json === 'object' && json !== null && !Array.isArray(json)
      ? (json as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

/** `tenantId` del token, o `null` si no está o no es string. */
export function tenantIdDelToken(token: string): string | null {
  const tenantId = leerPayloadJwt(token)?.['tenantId'];
  return typeof tenantId === 'string' && tenantId !== '' ? tenantId : null;
}
